import { createContext, useState, useContext } from "react";
import { PropTypes } from "prop-types";

const SaveForLaterContext = createContext(null);

export const SaveForLaterProvider = ({ defaultState, children }) => {
  const [saveForLaterState, setSaveForLaterState] = useState(
    defaultState || {},
  );

  const saveForLater = (variantIdentifier) =>
    setSaveForLaterState({
      ...saveForLaterState,
      [variantIdentifier]: { isSavedForLater: true, animationHasFired: false },
    });

  const saveForLaterAnimationFired = (variantIdentifier) =>
    setSaveForLaterState({
      ...saveForLaterState,
      [variantIdentifier]: {
        ...saveForLaterState[variantIdentifier],
        animationHasFired: true,
      },
    });

  const isSavedForLater = (variantIdentifier) =>
    saveForLaterState[variantIdentifier]?.isSavedForLater || false;

  const hasSavedForLaterAnimationFired = (variantIdentifier) =>
    saveForLaterState[variantIdentifier]?.animationHasFired || false;

  return (
    <SaveForLaterContext.Provider
      value={{
        saveForLater,
        saveForLaterAnimationFired,
        isSavedForLater,
        hasSavedForLaterAnimationFired,
      }}
    >
      {children}
    </SaveForLaterContext.Provider>
  );
};

SaveForLaterProvider.propTypes = {
  defaultState: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export const useSaveForLater = () => useContext(SaveForLaterContext);
